import { OBJECTS_CONTROLLER_TYPES } from '../reducers/types';
import { createAction } from './common';

export const setFullObjectsList = createAction(
  OBJECTS_CONTROLLER_TYPES.SET_FULL_OBJECTS_LIST
);
export const setFullObjectsListDictionary = createAction(
  OBJECTS_CONTROLLER_TYPES.SET_FULL_OBJECTS_LIST_DICTIONARY
);
